import React, { useState } from 'react';
import UserList from '../components/UserList';

const Users: React.FC = () => {
  const [limit, setLimit] = useState(10);
  const [sort, setSort] = useState('_id');

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8">
          <h1 className="text-4xl font-bold text-gray-900 dark:text-white mb-4">
            User Management 👥
          </h1>
          <p className="text-lg text-gray-600 dark:text-gray-300">
            Manage and view all registered users
          </p>
        </div>
        
        <div className="bg-white dark:bg-gray-800 rounded-xl shadow-lg">
          <div className="p-6 border-b border-gray-200 dark:border-gray-700">
            <div className="flex flex-col sm:flex-row gap-4 items-center justify-between">
              <div className="flex items-center space-x-4">
                <label className="text-sm font-medium text-gray-700 dark:text-gray-300">
                  Show:
                </label>
                <select
                  value={limit}
                  onChange={(e) => setLimit(Number(e.target.value))}
                  className="border border-gray-300 dark:border-gray-600 rounded-md px-3 py-2 bg-white dark:bg-gray-700 text-gray-900 dark:text-white text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                >
                  <option value={5}>5 users</option>
                  <option value={10}>10 users</option>
                  <option value={20}>20 users</option>
                  <option value={50}>50 users</option>
                </select>
              </div>
              
              <div className="flex items-center space-x-4">
                <label className="text-sm font-medium text-gray-700 dark:text-gray-300">
                  Sort by:
                </label>
                <select
                  value={sort}
                  onChange={(e) => setSort(e.target.value)}
                  className="border border-gray-300 dark:border-gray-600 rounded-md px-3 py-2 bg-white dark:bg-gray-700 text-gray-900 dark:text-white text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                >
                  <option value="_id">ID</option>
                  <option value="username">Username</option>
                  <option value="firstName">First Name</option>
                  <option value="lastName">Last Name</option>
                  <option value="createdAt">Created Date</option>
                  <option value="-createdAt">Created Date (Newest)</option>
                </select>
              </div>
            </div>
          </div>
          
          <UserList limit={limit} sort={sort} />
        </div>
      </div>
    </div>
  );
};

export default Users; 